import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.072 3.753c.311-.468.87-.753 1.443-.753.574 0 1.132.285 1.443.753a1.696 1.696 0 0 1 2.208 1.268 1.695 1.695 0 0 1 2.023 1.663v5.637A4.679 4.679 0 0 1 11.51 17h-1.186a4.68 4.68 0 0 1-3.893-2.084L4.1 11.423a1.73 1.73 0 0 1 2.664-2.184l.066.066V5.358a1.695 1.695 0 0 1 2.241-1.605Zm-.251 1.608v-.003a.295.295 0 0 0-.59 0v5.637a.7.7 0 0 1-1.195.495l-1.26-1.261a.33.33 0 0 0-.51.417l2.33 3.494a3.28 3.28 0 0 0 2.728 1.46h1.186a3.279 3.279 0 0 0 3.279-3.279V6.684a.295.295 0 0 0-.59 0v2.984a.7.7 0 0 1-1.4 0v-4.31a.295.295 0 0 0-.589-.002v4.312a.7.7 0 0 1-1.4 0V4.595c0-.028-.011-.069-.06-.112a.35.35 0 0 0-.235-.083.35.35 0 0 0-.235.083c-.048.043-.06.084-.06.112v5.073a.7.7 0 0 1-1.4 0V5.361Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=HandIcon20.js.map